"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.GetMonthlyTopMembersLeaderboardResponseToJSON = exports.GetMonthlyTopMembersLeaderboardResponseFromJSONTyped = exports.GetMonthlyTopMembersLeaderboardResponseFromJSON = void 0;
var _1 = require("./");
function GetMonthlyTopMembersLeaderboardResponseFromJSON(json) {
    return GetMonthlyTopMembersLeaderboardResponseFromJSONTyped(json, false);
}
exports.GetMonthlyTopMembersLeaderboardResponseFromJSON = GetMonthlyTopMembersLeaderboardResponseFromJSON;
function GetMonthlyTopMembersLeaderboardResponseFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'topMembers': (json['topMembers'].map(_1.RankedMemberFromJSON)),
    };
}
exports.GetMonthlyTopMembersLeaderboardResponseFromJSONTyped = GetMonthlyTopMembersLeaderboardResponseFromJSONTyped;
function GetMonthlyTopMembersLeaderboardResponseToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'topMembers': (value.topMembers.map(_1.RankedMemberToJSON)),
    };
}
exports.GetMonthlyTopMembersLeaderboardResponseToJSON = GetMonthlyTopMembersLeaderboardResponseToJSON;
